import { render, staticRenderFns } from "./home-atls.vue?vue&type=template&id=48ead3ca&scoped=true&"
import script from "./home-atls.vue?vue&type=script&lang=js&"
export * from "./home-atls.vue?vue&type=script&lang=js&"
import style0 from "./home-atls.vue?vue&type=style&index=0&id=48ead3ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ead3ca",
  null
  
)

export default component.exports